module.exports = __webpack_public_path__ + "static/media/watermark.cfdc4846.png";